import React from 'react';

const NavigationBar = ({
  as: Component = 'nav',
  className = '',
  ariaLabel,
  brand,
  items,
  cta,
  menuButton,
  menuRegionProps = {},
  menuOpen = false,
}) => {
  const classes = ['c-nav', className].filter(Boolean).join(' ');

  return (
    <Component className={classes} aria-label={ariaLabel} data-menu-open={menuOpen}>
      {brand ? <div className="c-nav__brand">{brand}</div> : null}
      <div className="c-nav__menu-region" {...menuRegionProps}>
        {menuButton ? <div className="c-nav__menu-button">{menuButton}</div> : null}
        <div className="c-nav__items">{items}</div>
      </div>
      {cta ? <div className="c-nav__cta">{cta}</div> : null}
    </Component>
  );
};

export default NavigationBar;
